export default __webpack_public_path__ + "static/usta-favicon-1128c1de2bcd08bcb608c580abe2ad66.png";